<template xmlns:v-on="http://www.w3.org/1999/xhtml">

</template>

<script>
    // import StorageBase from "./StorageBase";
    import StorageBase from "./ModelStorageBase";

    var jp = require('jsonpath');

    export default {
        name: 'model-replay',
        mixins: [StorageBase],
        props: {
            projectName: {
                type: String,
                default: function () {
                    return ''
                }
            },
            sliderLocationScale: {
                type: Number,
                default: function () {
                    return 1;
                }
            },
            value: {
                type: Object,
                default: function () {
                    return {'elements': {}, 'relations': {}}
                }
            },
            dragPageMovable: {
                type: Boolean,
                default: function () {
                    return false
                }
            },
            readOnly: {
                type: Boolean,
                default: function () {
                    return true
                }
            },
            imageBase: {
                type: String,
                default: function () {
                    return 'https://raw.githubusercontent.com/kimsanghoon1/k8s-UI/master/public/static/image/symbol/'
                }
            },
            snapshotDefaultThumbnail: {
                type: String,
                default: function () {
                    return null
                }
            },

        },
        data() {
            return {
                params: {
                    uid: null,
                    projectId: null,
                    snapshotKey: null,
                    queueKey: null,
                },
                snapshot: {
                    key: null,
                    value: null,
                },
                slider: {
                    sliderSize: -1,
                    sliderIndex: -1,
                    sliderLists: [],
                    sliderIndexImg: null,
                },

                queue: {
                    startQueueKey: null,
                    endQueueKey: null,
                }
            }
        },
        created: function () {
            var me = this
            me.init()

        },
        computed: {
            sliderSnapImg: function () {
                if(this.sliderLists){
                    return this.sliderLists[this.slider.sliderIndex].img
                }
                return null

                // return this.slider.sliderIndexImg
            },
            getQueueKey() {
                return this.$route.params.queueKey
            },
            getSnapKey() {
                return this.$route.params.snapshotKey
            },
            getProjectId() {
                return this.$route.params.projectId
            },
        },
        watch: {
            "slider.sliderIndex": function (newVal) {
                var me = this
                if (me.slider.sliderLists.length > 0 && newVal != -1) {
                    var newSnapKey = me.slider.sliderLists[newVal] && me.slider.sliderLists[newVal].snapKey ? me.slider.sliderLists[newVal].snapKey : 'last'
                    me.params.snapshotKey = newSnapKey
                }
            },
            "params.snapshotKey": async function (newVal, oldVal) {
                var me = this

                var getSnapObj = me.slider.sliderLists.find(snap => snap.snapKey == newVal)
                var getSnapIndex = me.slider.sliderLists.findIndex(snap => snap.snapKey == newVal)
                var getNextSnapObj = me.slider.sliderLists[getSnapIndex + 1]

                me.queue.startQueueKey = getSnapObj ? getSnapObj.lastQueueKey : 'last'
                me.queue.endQueueKey = getNextSnapObj ? getNextSnapObj.lastQueueKey : 'last'
                // me.slider.sliderIndexImg = getSnapObj ? (getSnapObj.img ? getSnapObj.img : me.snapshotDefaultThumbnail) : me.snapshotDefaultThumbnail

                me.move()

                me.changeUrl(null, null, '/#/replay/' + me.getProjectId + '/' + newVal + '/' + me.getQueueKey)
            },

        },
        methods: {
            async init() {
                var me = this
                var getSnapshotLists = await me.list(`db://definitions/${me.getProjectId}/snapshotLists`)

                if (getSnapshotLists) {
                    var findIndex = -1
                    var index = 0
                    Object.keys(getSnapshotLists).forEach(function (snapshotKey) {
                        var snapshotKey = snapshotKey
                        var value = getSnapshotLists[snapshotKey]
                        var lastKey = value.lastSnapshotKey
                        var img = value.snapshotImg

                        //url 유입시 필요.
                        if (me.getSnapKey == snapshotKey) {
                            findIndex = index
                        }
                        me.slider.sliderLists.push({snapKey: snapshotKey, lastQueueKey: lastKey, img: img})
                        index++;
                    })

                    me.slider.sliderSize = me.slider.sliderLists.length - 1

                    if (findIndex == -1) {
                        me.slider.sliderIndex = me.slider.sliderSize
                    } else {
                        me.slider.sliderIndex = findIndex
                    }

                } else {
                    me.slider.sliderSize = 1
                }

                me.params.uid = localStorage.getItem('uid')
                me.params.projectId = me.$route.params.projectId;
                me.params.snapshotKey = me.$route.params.snapshotKey;
                me.params.queueKey = me.$route.params.queueKey;
            },
            async move() {
                var me = this

                var snapKey = me.slider.sliderLists[me.slider.sliderIndex] ? me.slider.sliderLists[me.slider.sliderIndex].snapKey : me.slider.sliderLists[me.slider.sliderIndex - 1].snapKey

                if (me.snapshot.key != snapKey) {
                    var options = {
                        sort: null,
                        orderBy: null,
                        size: null,
                        startAt: snapKey,
                        endAt: snapKey,
                    }

                    var getSnapshot = await me.list(`db://definitions/${me.getProjectId}/snapshotLists`,options);

                    if (getSnapshot) {
                        me.snapshot.value = null
                        var snapshotValue = getSnapshot[0]
                        var snapshotKey = snapshotValue.key


                        me.snapshot.key = snapshotKey
                        me.value = me.migrateArrayToObject(JSON.parse(snapshotValue.snapshot))
                        me.snapshot.value = JSON.stringify(me.value)
                    }
                }
            },
            prevSnap() {
                var me = this
                if (!me.snapshot.value) {
                    me.snapshot.value = {'elements': {}, 'relations': {}}
                }
                me.value = (typeof me.snapshot.value == 'string') ? JSON.parse(me.snapshot.value) : me.snapshot.value
            },
            nextSnap() {
                this.slider.sliderIndex = this.slider.sliderIndex + 1
            },
            changeUrl(state, title, url) {
                if (typeof (history.pushState) != "undefined") { //브라우저가 지원하는 경우
                    history.pushState(state, title, url);
                } else {
                    location.href = url; //브라우저가 지원하지 않는 경우 페이지 이동처리
                }
            },
            shareUrl() {
                console.log('shareUrl')
            },
            migrateArrayToObject(value) {
                var me = this

                if (!value.version && value.version != 3) {
                    if (!value.relations) value.relations = {}
                    if (!value.elements) value.elements = {}

                    Object.keys(value).forEach(function (key, index) {
                        if (Array.isArray(value[key])) {
                            if (key.includes('relation')) {
                                Object.values(value[key]).forEach(function (relation, index) {
                                    if (relation)
                                        me.$set(value.relations, relation.relationView.id, relation)
                                })
                            } else if (key.includes('definition')) {
                                Object.values(value[key]).forEach(function (element, index) {
                                    if (element)
                                        me.$set(value.elements, element.elementView.id, element)
                                })
                            }
                        }
                    })
                    value.version = 3
                    console.log('load 1 to3')
                }
                delete value['definition'];
                delete value['relation'];

                return value
            },

        }
    }
</script>
